import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function QuantityMismatchModal({
  open,
  onClose,
  expectedQuantity,
  currentQuantity,
}) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <DialogTitle sx={{ p: 3 }}>
        <Typography align="center" color="error" sx={{ px: 2, fontWeight: 500, fontSize: 22 }}>
          Error
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 16, top: 16 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" pb={2}>
          <Typography
            color="textPrimary"
            align="center"
            sx={{ mb: 2, maxWidth: 500, fontWeight: 500 }}
          >
            Your quantities must match the received quantity of {expectedQuantity}.
          </Typography>

          <Typography color="textPrimary" align="center" sx={{ mb: 2, maxWidth: 500 }}>
            Right now, they add up to {currentQuantity}. Please adjust.
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
